import React, { useEffect, useRef, useState } from 'react';
import cls from '@utils/css-select';

import styles from './styles.scss';
import Section from 'components/section';
const cx = cls(styles);

const TabList = [
	{
		id: 'tab_01',
		name: 'SATs',
	},
	{
		id: 'tab_02',
		name: 'GCSE',
	},
	{
		id: 'tab_03',
		name: 'A-Level',
	},
];

const gradeMap = [
	{
		img: 'https://web-data.zmlearn.com/image/3uoqaeEoCiXeJBu75VBDB2/subjects_1%402x.png',
		title: 'SATs',
		details: [
			'Grade: 1-6',
			'Subjects: Reading, Maths, Grammar, Pronounciation and Spelling…',
			'Form: 1-on-1',
			'Learning plan and guidance provided: Yes',
			'Free trial session: Yes',
		],
	},
	{
		img: 'https://web-data.zmlearn.com/image/h13fpMk5EuP5hgPWQwC2AA/subjects_2%402x.png',
		title: 'GCSE',
		details: [
			'Grade: 7-11',
			'Subjects: Maths, English, Biology, Chemistry, Physics…',
			'Form: 1-on-1',
			'Learning plan and guidance provided: Yes',
			'Free trial session: Yes',
		],
	},
	{
		img: 'https://web-data.zmlearn.com/image/woNGo9xfZKQsdodszwYsG1/subjects_3%402x.png',
		title: 'A-Level',
		details: [
			'Grade: 12-13',
			'Subjects: Maths, English, Biology, Chemistry, Physics…',
			'Form: 1-on-1',
			'Learning plan and guidance provided: Yes',
			'Free trial session: Yes',
		],
	},
];

/**
 *年级区域
 * @export
 * @returns
 */
export default function GradeBlock() {
	const [curId, setCurId] = useState('tab_01');
	const ref = useRef<HTMLDivElement>(null);
	/**
	 * tab切换
	 */
	function handleTabClick(e: React.MouseEvent<HTMLLIElement>) {
		const { id = '' } = e.currentTarget.dataset;
		setCurId(id);
		const scrollRef = ref.current;
		const ele = document.querySelector(`#${id}`) as HTMLDivElement;
		const left = ele.offsetLeft;
		// eslint-disable-next-line no-unused-expressions
		scrollRef?.scrollTo(id === 'tab_01' ? 0 : left - 50, 0);
	}
	useEffect(() => {
		const scrollRef = ref.current;
		if (!scrollRef) return;
		const tabContent1 = document.querySelector(`#tab_01`) as HTMLDivElement;
		const tabContent2 = document.querySelector(`#tab_02`) as HTMLDivElement;
		const tabContent3 = document.querySelector(`#tab_03`) as HTMLDivElement;
		const offsets = [tabContent1.offsetLeft, tabContent2.offsetLeft, tabContent3.offsetLeft];
		function moveListener(e: Event) {
			const ele = e.currentTarget as HTMLDivElement;
			// ele.scrollLeft;
			if (ele.scrollLeft >= 0 && ele.scrollLeft < offsets[1] - 50) {
				setCurId('tab_01');
			} else if (ele.scrollLeft > offsets[1] - 100 && ele.scrollLeft < offsets[2] - 200) {
				setCurId('tab_02');
			} else {
				setCurId('tab_03');
			}
		}
		scrollRef.addEventListener('scroll', moveListener);
		return () => {
			scrollRef.removeEventListener('scroll', moveListener);
		};
	}, []);
	return (
		<div className={cx('grade-list')}>
			<Section>
				<div className={cx('circle', 's1')} />
				<div className={cx('circle', 's2')} />
				<div className={cx('circle', 's3')} />
				<h3 className={cx('block-title', 'black', 'grade-title')}>SATs | GCSE | A-Level all levels and all subjects</h3>
				<ul className={cx('tabs')}>
					{TabList.map((v) => {
						return (
							<li
								className={cx('tab', {
									active: v.id === curId,
								})}
								onClick={handleTabClick}
								key={v.name}
								data-id={v.id}>
								{v.name}
							</li>
						);
					})}
				</ul>
				<div className={cx('grade-scroll', 'scroll-view')} ref={ref}>
					{gradeMap.map((v, idx) => {
						return (
							<dl key={idx} className={cx('grade-item')} id={`tab_0${idx + 1}`}>
								<dt>
									<img loading="lazy" src={v.img} alt="" />
								</dt>
								<dd className={cx('grade-title')}>{v.title}</dd>
								<ul>
									{v.details.map((ite) => {
										return <li key={ite}>{ite}</li>;
									})}
								</ul>
							</dl>
						);
					})}
				</div>
			</Section>
		</div>
	);
}
